import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-chapter-content',
  templateUrl: './chapter-content.component.html',
  styleUrls: ['./chapter-content.component.css']
})
export class ChapterContentComponent implements OnInit {



  Submitted: boolean = false;
  BookTitleList = [];
  ChapterHeadingList = [];
  ChapterTopicList = [];
  SearchChapterHeadingList = [];
  SearchChapterTopicList = [];
  ChapterContentList = [];

  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;

  constructor(private learningservice: LearningService, private LookupService: LookupService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService, private _sanitizer: DomSanitizer) { }



  ClearSave() {
    this.ContentModel.ResourceID = 0;
    this.ContentModel.ResourceType = '0';
    this.ContentModel.ResourcePath = '';
    this.ContentModel.ResourceName = '';
    this.ContentModel.IsShared = false;
    this.SubmittedResource = false;
    if (this.SelectedFileForUpload != undefined && this.SelectedFileForUpload != null) {
      this.fileUploader.nativeElement.value = null;
      this.SelectedFileForUpload = '';
    }

  }


  SelectedFileForUpload: any;
  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };





  ContentModel = {
    BookTitleID: 0,
    ChapterID: 0,
    TopicID: 0,
    ResourceID: 0,
    ResourceType: '0',
    ContentTitle: '',
    ResourcePath: '',
    ResourceName: '',
    IsShared: false,
  };

  ClearResource() {
    this.ContentModel.BookTitleID = 0;
    this.ContentModel.ChapterID = 0;
    this.ContentModel.TopicID = 0;
    this.ContentModel.ResourceID = 0;
    this.ContentModel.ResourceType = '0';
    this.ContentModel.ResourcePath = '';
    this.ContentModel.ResourceName = '';
    this.ContentModel.IsShared = false;
    this.SubmittedResource = false;
    if (this.SelectedFileForUpload != undefined && this.SelectedFileForUpload != null) {
      this.fileUploader.nativeElement.value = null;
      this.SelectedFileForUpload = null;
    }
    this.ContentResourceList = [];
  }


  ValidityResorce() {
    return this.ContentModel.TopicID == 0 || this.ContentModel.ResourceType == '0';
  }
  SubmittedResource = false;
  SaveContentResource() {
    this.SubmittedResource = true;
    if (!this.ValidityResorce()) {
      this.spinnerService.show();
      this.learningservice.SaveContentResource(JSON.stringify(this.ContentModel), this.SelectedFileForUpload).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.GetAllContentResource();
          if (this.SelectedFileForUpload != undefined && this.SelectedFileForUpload != null)
            this.fileUploader.nativeElement.value = null;
          this.SelectedFileForUpload = null;
        }
        if (data.webResponse.Status && this.ContentModel.ResourceID == 0) {
          this.ClearSave();
        }
        this.SubmittedResource = false;
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }
  };

  ContentResourceList = [];
  GetAllContentResource() {
    this.spinnerService.show();
    this.learningservice.GetAllContentResource(this.ContentModel.TopicID).subscribe((data: any) => {
      this.ContentResourceList = data.ContentResourceList;
      if (this.ContentResourceList != null) {
        for (var i = 0; i < this.ContentResourceList.length; i++) {
          this.ContentResourceList[i].YouTubeUrls = this._sanitizer.bypassSecurityTrustResourceUrl(this.ContentResourceList[i].YouTubeUrls);

        }

      }
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });
  };

  DeleteContentResource(item) {
    this.ContentModel.ResourceID = item.ResourceID;
    if (confirm("Are you sure to delete this resource !")) {
      this.spinnerService.show();
      this.learningservice.DeleteContentResource(this.ContentModel.ResourceID).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.GetAllContentResource();
          this.ContentModel.ResourceID = 0;
        }

        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }

  };


  EditResource(item) {
    this.ContentModel.ResourceID = item.ResourceID;
    this.ContentModel.ResourceType = item.ResourceType;
    this.ContentModel.ResourceName = item.ResourceName;
    this.ContentModel.ResourcePath = item.ResourcePath != null ? item.ResourcePath : '';
    this.ContentModel.IsShared = item.IsShared;
  }

  MarkShareTopicResourse(item) {
    this.ContentModel.ResourceID = item.ResourceID;
    this.ContentModel.IsShared = item.IsShared == true ? false : true;
    this.spinnerService.show();
    this.learningservice.MarkShareTopicResourse(this.ContentModel.ResourceID,this.ContentModel.IsShared).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllContentResource();
      }
     
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  };
  ngOnInit() {
    this.GetBookTitle();
  }

  GetBookTitle() {
    this.LookupService.GetLookupsList('LearningBookTitle', '').subscribe((data: any) => {
      this.BookTitleList = data.LookupItems;
    });
  }

  GetChapterHeading() {
    this.ContentModel.ChapterID = 0;
    var ItemBO = {
      'ItemID': this.ContentModel.BookTitleID
    }
    this.LookupService.GetLookupsList('ChapterHeading', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.ChapterHeadingList = data.LookupItems;
    });

  }

  GetChapterTopic() {
    this.ContentModel.TopicID = 0;
    var ItemBO = {
      'ItemID': this.ContentModel.ChapterID
    }
    this.LookupService.GetLookupsList('ChapterTopic', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.ChapterTopicList = data.LookupItems;
    });

  }



}




